import CONSTANTS from '../lib/constants';
import { fetchRequest } from '../utils';
import { logError } from '../services/sentryService';

/* global locale */
const head = document.getElementsByTagName('head')[0];
/*
Structure to make it more scalable in case that we need to add more pages/banners
Names in the array are the same as the id of the containers in the templates
*/
const CHECKOUT_SIDE_BANNER = 'checkout-side-banner';
const bannersNames = {
  finish: ['checkout-middle-banner', CHECKOUT_SIDE_BANNER],
};

const getEnv = () => {
  return window.location.hostname[0] !== 'w' ? '-qa' : '';
};

/* to check if a script has been loaded before */
const isLoadedScript = (lib) =>
  document.querySelectorAll(`script[src="${lib}"]`).length > 0;

/* to check if a style has been loaded before */
const isLoadedStyle = (lib) =>
  document.querySelectorAll(`link[href="${lib}"]`).length > 0;

/*
Get the host (eg. bitiba.de, zooplus.es)
UK is treated differently as it has one more part (zooplus.co.uk)
*/
const getHost = () => {
  let hostname = window.location.hostname;
  if (hostname.includes('uk')) return hostname.split('.').slice(-3).join('.');
  else return hostname.split('.').slice(-2).join('.');
};

/*
Inject style tag with the given url
*/
const injectStyles = (url) => {
  if (isLoadedStyle(url)) return;
  const style = document.createElement('link');
  style.rel = 'stylesheet';
  style.type = 'text/css';
  style.href = url;
  head.appendChild(style);
};

/*
Inject script tag with the given url
*/
const injectScripts = (url) => {
  if (isLoadedScript(url)) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = url;
  head.appendChild(script);
};

/*
Build the contentful url
*/
const buildUrl = (bannerName) => {
  // locale is available globally
  let host = getHost();
  let env = getEnv();

  return `https://content-bff${env}.public.zooplus.net/${bannerName}/v1/${host}/${locale.replace(
    '_',
    '-'
  )}`;
};

/*
Request and process the banners
*/
const initBanners = () => {
  Object.keys(bannersNames).forEach((page) => {
    if (window.location.href.includes(page)) {
      bannersNames[page].forEach(async (bannerName) => {
        try {
          const response = await fetchRequest(
            buildUrl(bannerName),
            null,
            {},
            'get'
          );

          const container = document.getElementById(bannerName);
          response.css.forEach((css) => injectStyles(css));
          response.js.forEach((js) => injectScripts(js));
          if (container) container.innerHTML = response.html;
        } catch (error) {
          if (error?.message === CONSTANTS.ERROR_MESSAGES.EMPTY_BODY) return;
          logError(`Error when fetching banners from Contentful: ${error}`);
        }
      });
    }
  });
};

export { initBanners };
